import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.profSpheres.label': {
    id: 'profile.profSpheres.label',
    defaultMessage: 'Professional Sphere',
    description: 'The label for a professional sphere in a user profile.',
  },
  'profile.profSpheres.empty': {
    id: 'profile.profSpheres.empty',
    defaultMessage: 'Add professional sphere',
    description: "The affordance to add professional sphere to a user's profile.",
  },
  'profile.profSpheres.option.default': {
    id: 'profile.profSpheres.option.default',
    defaultMessage: 'Select a professional sphere',
  },
  'profile.profSpheres.placeholder': {
    id: 'profile.profSpheres.placeholder',
    defaultMessage: 'Fill in the information about your professional sphere',
  },
});

export default messages;
